import { get } from 'lodash';
import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import { isSafari } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ERROR_REASONS, ERROR_REFERENCE } from '../../../utils/errors';
import corgi from './corgi-error.png';

const ErrorPage = ({ error }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const localError = error || get(history, 'location.state.error', null);

  /**
   * The first switch is to get the type error, can be anything
   * The second switch is to handle where is coming from
   * @returns
   */
  const getErrorType = () => {
    const errorType = (localError && localError.type) || localError;
    switch (errorType) {
      case ERROR_REASONS.NOT_FOUND:
        switch (localError.cause.code) {
          case ERROR_REFERENCE.OFFER:
            return t('common.offer_not_found', {
              id: get(localError, 'cause.id')
            });
        }

        break;
      case ERROR_REASONS.UNAUTHORIZED:
        return t('common.errors.unauthorized', {
          id: get(localError, 'cause.id')
        });
    }
  };

  const showError = () => {
    if (!localError) return null;

    return (<React.Fragment>
      <div className="text-2">
        {localError.toString()}
      </div>
      {
        localError.stack &&
        <details className="text-2" style={{ whiteSpace: 'pre-wrap' }}>
          {localError && !isSafari && localError.stack.toString()}
        </details>
      }
    </React.Fragment>);
  };

  return (<div className="page">
    <Container>
      <Row>
        <Col xs={12} md={6}>
          <div className="justify-content-md-center row">
            <Image src={corgi} alt="Image error" />
          </div>
        </Col>

        <Col xs={12} md={6}>
          <h1>Oh no!</h1>
          <div className="text-1 mb-3">
            {t('common.message_error')}
          </div>
          <div className="text-2">
            {getErrorType()}
          </div>
          {showError()}
        </Col>
      </Row>
    </Container>
  </div>);
};

export default React.memo(ErrorPage);
